"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.builder = builder;
function builder(Type, template) {
    const built = template ? Object.assign({}, template) : {};
    const builder = new Proxy({}, {
        get(_target, prop) {
            if ('build' === prop) {
                return (value) => {
                    const type = new Type();
                    return Object.assign(type, { ...built, ...value });
                };
            }
            return (value) => {
                built[prop.toString()] = value;
                return builder;
            };
        },
    });
    return builder;
}
//# sourceMappingURL=builder.js.map